import type { MutableRefObject } from "react";

import classNames from "classnames";

import type { IAutocompleteProps } from "@similarweb/ui-components";
import { DotsLoader } from "@similarweb/ui-components";

import type { PrimaryWebsite } from "app/pages/activation/components/SetupModal/types";

import { DEBOUNCE_TIME, MAX_RESULTS } from "./config";
import * as SC from "./styles";
import type { ResentSchema } from "./types";
import { useAutocompleteWithKeys } from "./useAutocompleteWithKeys";

export type AutocompleteWebsitesWithKeysControlSchema = {
    renderOnEmptyQuery?: () => ResentSchema[];
    exclude?: string[];
    autocompleteRef: MutableRefObject<any>;
    onItemClick: (item: PrimaryWebsite) => void;
    placeholder?: string;
    height?: string;
    className?: string;
} & Partial<IAutocompleteProps>;

export const AutocompleteWebsitesWithKeysControl = ({
    renderOnEmptyQuery,
    exclude = [],
    autocompleteRef,
    onItemClick,
    placeholder,
    height,
    maxResults = MAX_RESULTS,
    className,
    ...autocompleteProps
}: AutocompleteWebsitesWithKeysControlSchema) => {
    const {
        onAutocompleteGetData,
        onEnterKeyPress,
        selectedIndex,
        getRenderItems,
        onArrowKeyPress,
        autocompleteLoading,
    } = useAutocompleteWithKeys({
        renderOnEmptyQuery,
        exclude,
        onItemClick,
        height,
        autocompleteRef,
        maxResults,
    });

    return (
        <SC.AutocompleteStyled
            className={classNames("AutocompleteWebsitesBase", "autoCompletePrimaryDomain", className)}
            ref={autocompleteRef}
            placeholder={<SC.PlaceholderText>{placeholder}</SC.PlaceholderText>}
            loadingComponent={<DotsLoader />}
            floating
            debounce={DEBOUNCE_TIME}
            getListItems={onAutocompleteGetData}
            renderItems={getRenderItems(onItemClick)}
            isLoading={autocompleteLoading}
            maxResults={maxResults}
            onArrowKeyPress={onArrowKeyPress}
            initialSelectedItemId={selectedIndex}
            overrideEnterFunc={onEnterKeyPress}
            {...autocompleteProps}
        />
    );
};

AutocompleteWebsitesWithKeysControl.displayName = "AutocompleteWebsitesWithKeysControl";
